var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 16,
    viewBox: "0 0 48 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7463 2L12.96 2.25165L10.0911 3.96287H4.8065L4.08193 7.08333H11.5636L11.7772 7.33498L8.9084 9.0462H3.62619L2.91916 12.0911L0.276836 14.0289L0 13.7772L2.69266 2.27684L3.01979 2H12.7463Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3725 14.0363H11.6453L11.3996 13.7907L14.1016 2.27032L14.421 2.00012H24.1482L24.3692 2.27032L21.6427 13.7907L21.3725 14.0363ZM21.5444 3.96521H16.2141L14.2981 12.0958H19.6285L21.5444 3.96521Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7819 14.0363H23.0547L22.8091 13.7907L25.5111 2.27032L25.8304 2.00012H35.5576L35.7787 2.27032L33.0521 13.7907L32.7819 14.0363ZM32.9539 3.96521H27.6235L25.7076 12.0958H31.0379L32.9539 3.96521Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0383 2.26712L44.344 13.6546L44.077 13.8982H41.8932L42.3317 11.9795H42.3522L44.2465 3.94221H38.9776L37.1359 11.7525L36.5337 13.8982H34.461L34.2184 13.6546L36.8894 2.26712L37.2051 2.00012H46.8201L47.0383 2.26712Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoon);
export default __webpack_public_path__ + "static/media/FOON.16e3c3bc4b3b5c6ff303dac32fbfe056.svg";
export { ForwardRef as ReactComponent };